import { APICfg } from 'services/api/api'
import { uploadOrKeepImg } from '../../common'
import { parseImage } from '../utils'
import { LocationFeatureToAPI } from './types/api/request-models'
import { APILocationFeature } from './types/api/response-models'
import { LocationFeature } from './types/internal/locationFeatures-models'

// ============
// PARSE
// ============

const locationFeatureParse = ({
  images,
  ...res
}: APILocationFeature): LocationFeature => ({
  ...res,
  image: parseImage(images[0]),
})

// ============
// WRITE
// ============

const locationFeatureWrite = async ({
  image: formImage,
  ...req
}: LocationFeature): Promise<LocationFeatureToAPI> => {
  const image = await uploadOrKeepImg(formImage)
  return {
    ...req,
    images: image ? [image] : [],
  }
}

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'locationfeature',
  parse: locationFeatureParse,
  write: locationFeatureWrite,
}

export default apiCfg
